<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">{{getRouteName($route.name)}}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <md-list>
            <!-- WebSocket status idicator -->
            <md-list-item
              :title="[wsConnected ? $lang.general.ws_icon_connected : $lang.general.ws_icon_not_connected]"
            >
              <md-icon style="margin: 0px;">{{wsConnected ? 'cloud_queue' : 'cloud_off'}}</md-icon>
            </md-list-item>

            <!-- Applications section -->
            <md-list-item :title="$lang.tooltip.devices">
              <router-link :to="{ name: 'Merito'}">
                <i class="material-icons">dashboard</i>
                <p class="hidden-lg hidden-md">Dashboard</p>
              </router-link>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </md-toolbar>
</template>

<script>
import format from "date-fns/format";
import snackBar from "@/components/SnackBar";

export default {
  components: {
    snackBar
  },
  data() {
    return {
      showNotificationCounter: false,
      notificationCounter: 0,
      offlineCounter: 0
    };
  },

  computed: {
    getLocation() {
      return this.$store.getters.getSettings.localization;
    },
    notifications() {
      return this.$store.getters.getNotificationList;
    },
    supportedApplications() {
      return this.$store.getters.getAuth.applications;
    },
    wsConnected() {
      return this.$store.getters.isConnected;
    }
  },

  watch: {
    notifications: function(payload, oldPayload) {
      this.showNotificationCounter = true;
      this.notificationCounter++;
    },
    wsConnected(newVal, oldVal) {
      if (newVal) {
        if (this.offlineCounter > 0) {
          this.offlineCounter = 0;
          this.$refs.snackbar.notify(this.$lang.messages.ws_online);
        }
      } else {
        this.offlineCounter++;
        this.$refs.snackbar.notify(this.$lang.messages.ws_offline);
      }
    }
  },

  methods: {
    getFormattedTime(timestamp) {
      return format(timestamp * 1000, "HH:mm:ss");
    },
    getRouteName(routeName) {
      return this.$lang.titles[routeName];
    },
    notificationView() {
      this.showNotificationCounter = false;
      this.notificationCounter = 0;
    },
    changeLocation(location) {
      this.$lang.setLang(location);
      this.$store.commit("setLocation", location);
    },
    getSelectedLocation() {
      return "/img/flags/" + this.getLocation + ".png";
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.location-flag {
  padding-right: 10px;
}
</style>
